import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { PurchaseSuggestion, SuggestionStatus } from 'src/app/models/purchase-suggestion';
import { UserService } from 'src/app/services/user.service';
import { BaseData } from '../../card-item/models/base-data.model';
import { DetailsCardItem } from '../../card-item/models/details-card-item.model';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Util } from 'src/app/util';
import { ToastService } from 'src/app/_core/services/toast.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-user-suggestions-item',
  templateUrl: './user-suggestions-item.component.html',
  styleUrls: ['./user-suggestions-item.component.scss'],
})
export class UserSuggestionsItemComponent implements OnInit {
  private readonly toastService = inject(ToastService);
  private readonly apiService = inject(ApiService);

  readonly showDeleteSuggestionDialog = signal<boolean>(false);
  readonly suggestionItemToDelete = signal<PurchaseSuggestion>(null);

  @Input()
  suggestionItem: PurchaseSuggestion;

  baseData: BaseData;
  detailsLeft: DetailsCardItem[] = [];
  detailsRight: DetailsCardItem[] = [];

  constructor(
    private userService: UserService,
    private datePipe: DatePipe,
    private translate: TranslateService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.buildBaseData();
    this.fillDetailsLeft();
    this.fillDetailsRight();
  }

  statusToClass(status: SuggestionStatus) {
    return 'item__status--' + status.toLocaleLowerCase();
  }

  handleSuggestionToDelete(suggestion: PurchaseSuggestion) {
    this.showDeleteSuggestionDialog.set(true);
    this.suggestionItemToDelete.set(suggestion);
  }

  deleteSuggestion() {
    this.showDeleteSuggestionDialog.set(false);
    this.apiService.cancelUserPurchaseSuggestions(this.suggestionItemToDelete()).subscribe(() => {
      this.userService.purchaseSuggestions = this.userService.purchaseSuggestions.filter((suggestion) => suggestion.id !== this.suggestionItemToDelete().id);
      this.toastService.showToast('messages.suggestions.removed');
    });
  }

  openItemInfo() {
    if (
      this.suggestionItem.status === SuggestionStatus.BOUGHT &&
      this.suggestionItem?.record &&
      this.suggestionItem?.record?.id !== ''
    ) {
      this.router.navigate(['/info', this.buildSlug()]);
    }
  }

  buildSlug(): string {
    let toSlug = this.suggestionItem.title ?? '';
    return Util.slugify(toSlug) + '-' + this.suggestionItem?.record?.id;
  }

  private fillDetailsLeft() {
    this.detailsLeft.push({
      label: this.translate.instant('user.suggestions.status'),
      data: this.translate.instant(`user.suggestions.statuses.${this.suggestionItem.status.toLowerCase()}`),
      class: this.suggestionItem.status,
    });
  }

  private fillDetailsRight() {
    const creationDate = this.datePipe.transform(this.suggestionItem?.creationDate);
    if (creationDate) {
      this.detailsRight.push({
        label: this.translate.instant('user.suggestions.request'),
        data: creationDate,
      });
    }
  }

  private buildBaseData() {
    this.baseData = {
      record: {
        id: '',
        title: this.suggestionItem.title,
        ...this.suggestionItem.record,
      },
      author: this.suggestionItem.author,
      title: this.suggestionItem.title,
      cover: this.suggestionItem.coverUrl,
      icon: this.suggestionItem.icon,
    };
  }
}
